export const appConfig = Object.freeze({
  API_URL: window.runConfig.REACT_APP_API_URL,
  SSO_AUTHORITY: window.runConfig.REACT_APP_SSO_AUTHORITY,
  SSO_CLIENT_ID: window.runConfig.REACT_APP_SSO_CLIENT_ID,
  FUNCTIONS_KEY: window.runConfig.REACT_APP_FUNCTIONS_KEY,
  SSO_ENABLED: window.runConfig.REACT_APP_SSO_ENABLED,
  DOWNLOAD_TRANSCRIPT_ENABLED: window.runConfig.REACT_APP_DOWNLOAD_TRANSCRIPT_ENABLED,
});

export const appInsightConfig = Object.freeze({
  APPINSIGHTS_KEY: window.runConfig.REACT_APP_APPINSIGHTS_KEY,
  ANALYTICS_DASHBOARD:
    "https://portal.azure.com/#blade/AppInsightsExtension/UsageNotebookBlade/ComponentId/%2Fsubscriptions%2Fac3eb02e-41a4-435c-b6dc-3097fd3b411e%2Fresourcegroups%2Fcapabilities-gen-ai%2Fproviders%2Fmicrosoft.insights%2Fcomponents%2Faihub_insights_prod_frontend/ConfigurationId/%2Fsubscriptions%2Fac3eb02e-41a4-435c-b6dc-3097fd3b411e%2Fresourcegroups%2Fcapabilities-gen-ai%2Fproviders%2Fmicrosoft.insights%2Fworkbooks%2F47d440b8-a4ed-4642-bd02-83665e6e607c/Type/usage/WorkbookTemplateName/AI%20HUB%20-%20User%20analytics", //  TODO! Create an update dev analytics URL here
});

export const helpLinks  = Object.freeze({
  "VIDEO_GUIDE": "http://diit.nyc/hellovideoguide",
  "USER_GUIDE": "https://docs.google.com/document/d/1zlsed2Qq791W0sjTo0Rej19L3pML1KAFS_TdROcmKFI/edit?tab=t.0"
})
